import { getIn, connect } from 'formik';
import PropTypes from 'prop-types';

import { getTotalGiftsAmount } from '../../../../utils/gifts';

import style from './index.module.scss';

const ErrorMessage = (props) => {
  const { formik, onSetAmountsEqually, onUpdateGlobalAmountFromGifts } = props;
  const globalAmount = getIn(formik.values, 'donation_order[amount]');
  const gifts = getIn(formik.values, 'donation_order[gifts_attributes]');
  const totalGiftsAmount = getTotalGiftsAmount(gifts);

  // eslint-disable-next-line eqeqeq
  if (globalAmount == totalGiftsAmount) {
    return null;
  }

  return (
    <div
      className={`flex flex-center ${style.component}`}
      data-testid="gifts-error-message"
    >
      <i className="icon-exclamation icon-size--200 push-half--right" />
      <div className="text--center flex-grow--1">
        <div className="weight--normal f-size--1-3 push-half--bottom">
          {__('This amount is different from the one you first wrote.')}
        </div>
        <div className="flex flex-center flex--justify-center">
          <div
            onClick={onUpdateGlobalAmountFromGifts}
            className="push--right cursor-pointer"
          >
            {__('Keep this new amount')}
          </div>
          <div onClick={onSetAmountsEqually} className="cursor-pointer">
            {__('Go back to the first amount')}
          </div>
        </div>
      </div>
    </div>
  );
};

ErrorMessage.propTypes = {
  onSetAmountsEqually: PropTypes.func.isRequired,
  onUpdateGlobalAmountFromGifts: PropTypes.func.isRequired,
};

export default connect(ErrorMessage);
